module.exports = __webpack_public_path__ + "img/auto-email-text.e395bea7.png";